<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-30 15:33:09
 * @LastEditTime: 2019-08-11 11:33:19
 * @LastEditors: Please set LastEditors
 -->
<!-- 错误提示 -->
<template>
  <transition name="fade">
    <div id="toastComponent">
      <p class="text">{{text}}</p>
    </div>
  </transition>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: ['text'],
  mounted () {
    setTimeout(() => {
      this.$emit('clear', true)
    }, 2000)
  }
}
</script>
<style scoped lang='scss'>
#toastComponent {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  color: #fff;
  .text {
    // width: auto;
    position: absolute;
    padding: 0 vw(30);
    // height: 40px;
    line-height: 40px;
    background-color: #000;
    padding: rem(20);
    opacity: 0.7;
    border-radius: 6px;
    left: 50%;
    top: 40%;
    transform: translateX(-50%);
    text-align: center;
    color: #fff;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.8s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
@include isMobile {
  #toastComponent {
    .text {
      // width: 260px;
      line-height: 40px;
      padding: 0 rem(10);
    }
  }
}
</style>
